    /// Main search input
    $(document).on('click', '#pageheader .search-box .search-form .search-box-label', function(e){
      $('#pageheader .search-box input[type="text"]').focus();
      return false;
    });
    $(document).on('focusin focusout', '#pageheader .search-box input[type="text"]', function(e){
      $(this).closest('.search-box').toggleClass('focus', e.type == 'focusin');
    });
    $(document).on('mousedown', '#pageheader .search-box button', function(e){
      $(this).click();
    });


    /// Live search
    var preLoadLoadGif = $('<img src="//www.whitemountainpuzzles.com/cdn/shop/t/124/assets/ajax-load.gif?v=62939699503414190391791336677" />');
    var searchTimeoutThrottle = 500;
    var searchTimeoutID = -1;
    var currReqObj = null;
    $(document).on('keyup change', '#pageheader .search-box input[type="text"]', function(){
      var $resultsBox = $('#pageheader .search-box .results-box');
      if($resultsBox.length == 0) {
        $resultsBox = $('<div class="results-box" />').appendTo('#pageheader .search-box .search-form');
      }

      //Only search if search string longer than 2, and it has changed
      if($(this).val().length > 2 && $(this).val() != $(this).data('oldval')) {
        //Reset previous value
        $(this).data('oldval', $(this).val());

        // Kill outstanding ajax request
        if(currReqObj != null) currReqObj.abort();

        // Kill previous search
        clearTimeout(searchTimeoutID);

        var $form = $(this).closest('form');

        //Search term (no wildcards; Shopify prefix option handles partial matches)
        var term = $.trim($form.find('input[name="q"]').val());

        //Types
        var types = $form.find('input[name="type"]').val() || 'product';

        //URL for full search page
        var linkURL = $form.attr('action') + '?type=' + encodeURIComponent(types) + '&options%5Bprefix%5D=last&q=' + encodeURIComponent(term);

        //Show loading
        $resultsBox.html('<div class="load"></div>');

        // Do next search (in X milliseconds)
        searchTimeoutID = setTimeout(function(){
          //Ajax hit on search page
          currReqObj = $.ajax({

            url: $form.attr('action'),
            data: {
              type: types,
              view: 'json',
              q: term,
              'options[prefix]': 'last'
            },
            dataType: "json",
            success: function(data){
              currReqObj = null;
              if(data.results_total == 0) {
                //No results
                $resultsBox.html('<div class="note">No puzzles found</div>');
              } else {
                //Numerous results
                $resultsBox.empty();
                $.each(data.results, function(index, item){
                  var $row = $('<a></a>').attr('href', item.url);
                  $row.append('<div class="img"><img src="' + item.thumb + '" /></div>');
                  $row.append(item.title);
                  $resultsBox.append($row);
                });
                $resultsBox.append([
                  '<a href="', linkURL, '" class="note">',
                  "See all results",
                  ' (', data.results_total, ')</a>'].join(''));
              }
            }
          });
        }, searchTimeoutThrottle);
      } else if ($(this).val().length <= 2) {
        //Deleted text? Clear results
        $resultsBox.empty();
      }
    });
    $(document).on('focusin', '#pageheader .search-box input[type="text"]', function(){
      // show existing results
      $('#pageheader .search-box .results-box').show();
    });
    $(document).on('click', '#pageheader .search-box input[type="text"]', function(e){
      $('#pageheader .search-box .results-box').show();
      return false; // prevent body from receiving click event
    });
    $('body').bind('click', function(){
        //Click anywhere on page, hide results
        $('#pageheader .search-box .results-box').hide();
    });

    //Search box: products only, partial match on last word via Shopify prefix option
    $(document).on('submit', '.search-form, #search-form, .mobile-search', function(e){
      var val = $.trim($(this).find('input[name="q"]').val());
      if(val.length > 0) {
        e.preventDefault();
        var type = $(this).find('input[name="type"]').val() || 'product';
        var linkURL = $(this).attr('action') + '?type=' + encodeURIComponent(type) + '&options%5Bprefix%5D=last&q=' + encodeURIComponent(val);
        window.location = linkURL;
      }
    });
        //Take over search submit before any other script can add wildcards
    document.addEventListener('submit', function(e){
      var f = e.target;
      if (!f.matches || !f.matches('.search-form, #search-form, .mobile-search, .main-search__form')) return;
      var input = f.querySelector('input[name="q"]');
      var val = input ? input.value.replace(/\*/g, '').trim() : '';
      if (!val) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var typeInput = f.querySelector('input[name="type"]');
      var type = (typeInput && typeInput.value) || 'product';
      window.location = f.getAttribute('action') + '?type=' + encodeURIComponent(type) + '&options%5Bprefix%5D=last&q=' + encodeURIComponent(val);
    }, true);

    //Backstop: clean any search URL that still arrives with asterisks
    (function(){
      if (window.location.pathname.indexOf('/search') !== 0) return;
      var params = new URLSearchParams(window.location.search);
      var q = params.get('q');
      if (q && q.indexOf('*') !== -1) {
        params.set('q', q.replace(/\*/g, '').trim());
        if (!params.has('options[prefix]')) params.set('options[prefix]', 'last');
        window.location.replace(window.location.pathname + '?' + params.toString());
      }
    })();